// This file is useless but allows mocking in jest to compare module and mocked module
// because jest has troubles mocking index file

import PaymentsContextProvider from "./Context";
export default PaymentsContextProvider;

export { usePayments } from "./Context";
